import createIcon from '../../createIcon';

/**
 * @component @name EmojiFoodBeverage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTlIMlYyMUgyMFYxOVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMCAzSDRWMTNDNCAxNS4yMSA1Ljc5IDE3IDggMTdIMTRDMTYuMjEgMTcgMTggMTUuMjEgMTggMTNWMTBIMjBDMjEuMTEgMTAgMjIgOS4xMSAyMiA4VjVDMjIgMy44OSAyMS4xMSAzIDIwIDNaTTE2IDEzQzE2IDE0LjEgMTUuMSAxNSAxNCAxNUg4QzYuOSAxNSA2IDE0LjEgNiAxM1Y1SDlWNi40TDcuMTkgNy44NUM3LjA3IDcuOTQgNyA4LjA5IDcgOC4yNFYxMi41QzcgMTIuNzggNy4yMiAxMyA3LjUgMTNIMTEuNUMxMS43OCAxMyAxMiAxMi43OCAxMiAxMi41VjguMjRDMTIgOC4wOSAxMS45MyA3Ljk0IDExLjgxIDcuODVMMTAgNi40VjVIMTZWMTNaTTkuNSA3LjI4TDExIDguNDhWMTJIOFY4LjQ4TDkuNSA3LjI4Wk0yMCA4SDE4VjVIMjBWOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EmojiFoodBeverage = createIcon('EmojiFoodBeverage', [
  ['path', { d: 'M20 19H2V21H20V19Z', key: '1w6152' }],
  [
    'path',
    {
      d: 'M20 3H4V13C4 15.21 5.79 17 8 17H14C16.21 17 18 15.21 18 13V10H20C21.11 10 22 9.11 22 8V5C22 3.89 21.11 3 20 3ZM16 13C16 14.1 15.1 15 14 15H8C6.9 15 6 14.1 6 13V5H9V6.4L7.19 7.85C7.07 7.94 7 8.09 7 8.24V12.5C7 12.78 7.22 13 7.5 13H11.5C11.78 13 12 12.78 12 12.5V8.24C12 8.09 11.93 7.94 11.81 7.85L10 6.4V5H16V13ZM9.5 7.28L11 8.48V12H8V8.48L9.5 7.28ZM20 8H18V5H20V8Z',
      key: 'i6ubm5',
    },
  ],
]);

export default EmojiFoodBeverage;
